import React, { PureComponent } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import smoothscroll from 'smoothscroll-polyfill';

import backToTop from 'themes/[theme]/assets/images/icons/header/chevron.svg';

const offsetThreshold = 100;

export default class BackToTopButton extends PureComponent {
  state = {
    isVisible: false,
  };

  componentDidMount() {
    smoothscroll.polyfill();
    document.addEventListener('scroll', this.watchTopOffset);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.watchTopOffset);
  }

  watchTopOffset = () => {
    if ((window.scrollY > offsetThreshold || window.pageYOffset > offsetThreshold) && !this.state.isVisible) {
      this.setState({
        isVisible: true,
      });
    }
    if ((window.scrollY <= offsetThreshold || window.pageYOffset <= offsetThreshold) && this.state.isVisible) {
      this.setState({
        isVisible: false,
      });
    }
  };

  scrollTop = (e) => {
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  render() {
    return (
      <CSSTransitionGroup
        transitionName="gn-topButton"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={100}
      >
        {this.state.isVisible && (
          <a className="gn-backToTopButton__link" href="#react-view" onClick={this.scrollTop}>
            <img className="gn-backToTopButton__image" src={backToTop} alt="Top button" />
            <span className="gn-backToTopButton__label">Top</span>
          </a>
        )}
      </CSSTransitionGroup>
    );
  }
}
